import { render } from "./Supply.vue?vue&type=template&id=9ba615be&scoped=true&ts=true"
import script from "./Supply.vue?vue&type=script&lang=ts"
export * from "./Supply.vue?vue&type=script&lang=ts"

import "./Supply.vue?vue&type=style&index=0&id=9ba615be&lang=scss"
import "./Supply.vue?vue&type=style&index=1&id=9ba615be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba615be"]])

export default __exports__